/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { Link, Redirect } from 'react-router-dom';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Toast, ToastProvider, ToastViewport } from './ui/snackbar';

import Card from './Card';
import UpdateChannelMutation from '../mutations/UpdateChannelMutation';

class Channel extends React.Component {
  constructor(props) {
    super(props);
    this.onSnackClose = this.onSnackClose.bind(this);
    this.save = this.save.bind(this);
    this.state = {
      callbackUrl: props.channel.callbackUrl || 'https://',
      snackOpen: false,
    };
  }

  onSnackClose() {
    return this.setState({
      snackOpen: false,
    });
  }

  save(e) {
    e.preventDefault();
    return UpdateChannelMutation.commit(
      this.state.callbackUrl,
      null,
      this.props.channel.id,
      resp => {
        return this.setState({
          snackOpen: true,
        });
      },
    );
  }

  render() {
    const { channel } = this.props;

    if (this.state.redirect) {
      return <Redirect to="/" />;
    }

    if (this.state.successChannelId) {
      return <Redirect to={`/messages/${this.state.successChannelId}`} />;
    }

    return (
      <Card className="p-4">
        <h2 className="text-2xl font-semibold mb-4">
          {this.props.channel.name}
        </h2>
        <p className="text-sm mb-2">Channel ID: {this.props.channelId}</p>
        <p className="text-sm mb-4">
          Specify a webhook endpoint to receive a POST request for each event.
          For more information refer to the{' '}
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://pushback.io/docs/webhooks"
            className="text-primary underline"
          >
            webhook docs
          </a>
        </p>
        <div className="flex flex-col space-y-2">
          <div className="flex flex-col space-y-2">
            <Label htmlFor="webhook-endpoint">Webhook endpoint</Label>
            <Input
              id="webhook-endpoint"
              onChange={e => this.setState({ callbackUrl: e.target.value })}
              value={this.state.callbackUrl}
              className="w-[240px]"
            />
          </div>
          <div className="flex gap-2">
            <Button onClick={this.save}>Save</Button>
            {this.state.callbackUrl ? (
              <Button asChild variant="outline">
                <Link
                  to={{
                    pathname: `/channel_callback/${channel.id}`,
                  }}
                >
                  Customize Webhook
                </Link>
              </Button>
            ) : null}
          </div>
        </div>
        <ToastProvider>
          <Toast
            open={this.state.snackOpen}
            onOpenChange={open => !open && this.onSnackClose()}
          >
            <span>Saved!</span>
          </Toast>
          <ToastViewport />
        </ToastProvider>
      </Card>
    );
  }
}

Channel = createFragmentContainer(Channel, {
  channel: graphql`
    fragment Channel_channel on OwnedChannel {
      id
      joinedChannelId
      subscribed
      name
      callbackUrl
    }
  `,
});

export default Channel;
